// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3SkRm","upload":"Small_upload__2Br8T","imageWrap":"Small_imageWrap__zpK95","removeBtn":"Small_removeBtn__1-FP7"};